import React from 'react';
import styled from 'styled-components';

export default styled(({ className, value }) => (
  <h2 className={className}>{value}</h2>
))``;
